<header>
  <div><h2 mat-dialog-title>Waiting for payment</h2><p>{{ items.length }} pending {{ items.length === 1 ? 'booking' : 'bookings' }}</p></div>
  <button type="button" mat-dialog-close class="pending-dialog-close" aria-label="Close waiting payments" title="Close">&times;</button>
</header>
<mat-dialog-content>
  <article *ngFor="let item of items">
    <div class="details">
      <h3>Booking {{ item.row.bookingId }}</h3>
      <p *ngIf="item.expires; else noExpiry">Expires {{ item.expires | date:'dd MMM yyyy, h:mm a' }}</p>
      <ng-template #noExpiry><p>{{ item.unlimited ? 'No expiry' : 'Expiry unavailable' }}</p></ng-template>
      <span class="amount">{{ item.row.netAmount | currency:'INR':'symbol':'1.2-2' }}</span>
    </div>
    <button mat-flat-button [mat-dialog-close]="item" class="payment-action">
      {{ item.canPay ? 'Pay now' : 'View booking' }}<i class="fa fa-arrow-right" aria-hidden="true"></i>
    </button>
  </article>
</mat-dialog-content>
<mat-dialog-actions align="end"><button mat-button mat-dialog-close>Not now</button></mat-dialog-actions>
